import React from "react";
import { HeadLine } from "../modules/HeadLine";
import { LiabilitiesTable } from "../modules/Liabilities";

const Liabilities = () => {
  return (
    <div style={{ flex: "80%", padding: "2rem" }}>
      <HeadLine
        headingText={"Liabilities"}
        tagLine={"A list of your account’s deductions"}
      />
      <LiabilitiesTable />
    </div>
  );
};

Liabilities.propTypes = {};

export default Liabilities;
